import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomFunction {
  id: string;
  name: string;
}

interface ProcessGroup {
  id: string;
  name: string;
}

interface Process {
  process_id: string;
  name: string;
}

interface IdeationFormState {
  customFunctions: CustomFunction[];
  processGroups: ProcessGroup[];
  processes: Process[];
  loadedDomain: string;
  loadedFunctionId: string;
  loadedProcessGroupId: string;
  versionedReports: Record<string, Record<string, string>>; // usecaseId -> {version: report}
}

const initialState: IdeationFormState = {
  customFunctions: [],
  processGroups: [],
  processes: [],
  loadedDomain: '',
  loadedFunctionId: '',
  loadedProcessGroupId: '',
  versionedReports: {},
};

const ideationFormSlice = createSlice({
  name: 'ideationForm',
  initialState,
  reducers: {
    setCustomFunctions: (
      state,
      action: PayloadAction<{ functions: CustomFunction[]; domain: string }>
    ) => {
      state.customFunctions = action.payload.functions;
      state.loadedDomain = action.payload.domain;
    },
    setProcessGroups: (
      state,
      action: PayloadAction<{ processGroups: ProcessGroup[]; functionId: string }>
    ) => {
      state.processGroups = action.payload.processGroups;
      state.loadedFunctionId = action.payload.functionId;
    },
    setProcesses: (
      state,
      action: PayloadAction<{ processes: Process[]; processGroupId: string }>
    ) => {
      state.processes = action.payload.processes;
      state.loadedProcessGroupId = action.payload.processGroupId;
    },
    resetFunctions: (state) => {
      state.customFunctions = [];
      state.processGroups = [];
      state.processes = [];
      state.loadedDomain = '';
      state.loadedFunctionId = '';
      state.loadedProcessGroupId = '';
    },
    resetProcessGroups: (state) => {
      state.processGroups = [];
      state.processes = [];
      state.loadedFunctionId = '';
      state.loadedProcessGroupId = '';
    },
    resetProcesses: (state) => {
      state.processes = [];
      state.loadedProcessGroupId = '';
    },
    setVersionedReports: (
      state,
      action: PayloadAction<{ usecaseId: string; versionedReports: Record<string, string> }>
    ) => {
      const { usecaseId, versionedReports } = action.payload;

      // Ensure parent object exists
      if (!state.versionedReports) state.versionedReports = {};

      // Merge with existing reports for the usecase
      state.versionedReports[usecaseId] = {
        ...state.versionedReports[usecaseId],
        ...versionedReports,
      };
    },
  },
});

export const {
  setCustomFunctions,
  setProcessGroups,
  setProcesses,
  resetFunctions,
  resetProcessGroups,
  resetProcesses,
  setVersionedReports,
} = ideationFormSlice.actions;

export default ideationFormSlice.reducer;
